import GenericBuilderPage from '@/components/builder/GenericBuilderPage';
import { beweegaanbodBuilderAPI } from '@/lib/api';

export default function BeweegaanbodBuilderPage() {
  return (
    <GenericBuilderPage
      api={beweegaanbodBuilderAPI}
      branding={{
        kindLabel: 'Beweegaanbod Builder',
        title: 'Stel jouw beweegaanbod samen',
        subtitle: 'Kies een type beweegaanbod en stel de invulling zelf samen.',
        headlinePrefix: 'Stel jouw ',
        headlineHighlight: 'beweegaanbod',
        headlineSuffix: ' samen',
        ctaLabel: 'Start samenstellen',
        successTitle: 'Bedankt!',
        successMessage: 'We hebben je beweegaanbod ontvangen. We nemen binnen 1-2 werkdagen contact met je op om de details af te stemmen.',
        accent: 'blue',
        testIdPrefix: 'beweegaanbod-builder',
      }}
    />
  );
}
